module.exports = __webpack_public_path__ + "img/img-dc3bbd.jpg";